// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button } from "../../../revvComponents";

import { FIELDS_STRING } from "../../../stringConstants";

class ChangingObjectConfirmationPopup extends Component {
  state = {};

  _updateObject = () => {
    this.props.updateCurrObj(this.props.dsObject.name);
    this.props.closePopup();
  };

  _onClose = () => {
    this.props.closePopup();
  };

  render() {
    return (
      <Modal
        open
        onClose={this.props.closePopup}
        closeOnOverlayClick={false}
        center>
        <div
          className="modal-container object-change-popup-container"
          data-test="object-change-popup-container">
          <div
            className="modal-heading"
            data-test="object-change-popup-modal-heading">
            {FIELDS_STRING.CHNG_OBJ_WARNING_TITLE}
          </div>
          <div className="modal-form">
            <div
              className="modal-form-field"
              data-test="object-change-popup-form">
              {FIELDS_STRING.CHNG_OBJ_WARNING_SUBTITLE}
            </div>
          </div>

          <div className="modal-footer">
            <Button
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="object-change-popup-cancle-btn"
              onClick={this.props.closePopup}>
              Cancel
            </Button>
            <Button
              type="four"
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="object-change-popup-submit-btn"
              onClick={this._updateObject}>
              Sure, continue
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ChangingObjectConfirmationPopup;
